import { TimePicker } from 'antd'
import { useState } from 'react'
import moment from 'moment'

export default TimeInput = ({ value, ...props }) ->

  try
    value = moment(value, "HH:mm:ss")
    if not value.isValid() then throw new Error("Invalid time")
  catch e
    value = moment()

  <TimePicker
    { ...props }
    value={value}
  />
